import type { PersonaId } from "@petci/domain";

export const USAGE_TREND: Record<PersonaId, number> = {
  P1: 8.7,
  P2: 6.2,
  P3: 4.1,
  P4: 2.3,
  P5: 0,
};

export type HomeContextCard =
  | {
      kind: "solar";
      capacityKW: number;
      panels: number;
      periodLabel: string;
      exportKWh: number;
      creditUSD: number;
      offsetPct: number;
    }
  | {
      kind: "usage";
      periodLabel: string;
      usageKWh: number;
      trendPct: number;
      highlightFigure: string;
      /** English fallback (mobile home, English until Phase 3 parity). */
      highlightLabel: string;
      /** i18n key the web home resolves via t() (H2 / D6). SSoT-paired with highlightLabel. */
      highlightLabelKey: string;
    };

export const HOME_CONTEXT_PER_PERSONA: Record<PersonaId, HomeContextCard | null> = {
  P1: { kind: "solar", capacityKW: 4.0, panels: 16, periodLabel: "April", exportKWh: 142, creditUSD: 87, offsetPct: 38 },
  P2: { kind: "usage", periodLabel: "May", usageKWh: 1442, trendPct: 6.2, highlightFigure: "$22", highlightLabel: "avg cost per dive day", highlightLabelKey: "home.contextHighlightDiveDay" },
  P3: null,
  P4: null,
  P5: null,
};
